import { DynamicComponentExitReason } from '@jack-henry/frontend-utils/lit/dynamic-component-registry';
import { IvdBase } from '@treasury/domain-components/identity-verification-dialog/identity-verification-dialog.base';
import {
    IdentityDialogEvent,
    IdentityDialogResultInternal,
} from '@treasury/domain-components/identity-verification-dialog/identity-verification-dialog.types';
import { type SecurityMessage } from '@treasury/domain/channel/mappings/security';
import { css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OmegaDialogResult } from '../../services';
import { createDialogStrategy } from './strategies';

import '../../components/omega-button';
import '../../components/omega-dialog';
import '../../components/omega-input';
import '../../components/progress/omega-progress';

@customElement('omega-identity-verification-dialog')
export class OmegaIdentityVerificationDialog extends IvdBase {
    static get styles() {
        return css`
            .caption {
                padding: 10px;
            }
            .caption p:first-of-type {
                margin-top: 0;
            }
            .caption p:last-of-type {
                margin-bottom: 0;
            }
            .error {
                font-size: 8pt;
                font-weight: bold;
                padding: 0;
                padding-top: 1px;
            }
            .input-wrapper {
                margin: 20px;
            }
            .alert-wrapper {
                padding: 0 8px;
            }
            input {
                width: 100%;
                height: 32px;
                line-height: 34px;
                border: 1px solid var(--omega-input-default-border);
                padding: 0px 10px;
                border-radius: var(--omega-input-border-radius);
                font-size: 16px;
                box-sizing: border-box;
            }
            omega-dialog {
                width: 25%;
                z-index: 1026;
            }
            omega-progress {
                margin: 25px auto;
            }
            .success-message {
                padding: 10px;
                text-align: center;
            }
        `;
    }

    protected createDialogStrategy(challengeMethodType: SecurityMessage['challengeMethodTypeId']) {
        return createDialogStrategy(this, challengeMethodType);
    }

    protected close(reason: DynamicComponentExitReason, result: IdentityDialogResultInternal) {
        const dialogResult: OmegaDialogResult<IdentityDialogResultInternal> = {
            reason,
            data: result,
        };

        this.dispatchEvent(
            new CustomEvent(IdentityDialogEvent.Close, {
                detail: dialogResult,
                bubbles: true,
            })
        );
    }

    protected renderError(errorMessage?: string) {
        if (!errorMessage) {
            return nothing;
        }

        return html`<div class="alert-wrapper">
            <omega-alert type="error" isVisible .closeable=${false}>
                <div class="error">${errorMessage}</div>
            </omega-alert>
            <div name="actions">
                <omega-button type="link" @click=${this.cancel}>Close</omega-button>
            </div>
        </div>`;
    }

    protected renderProgress() {
        if (!this.verifying) {
            return nothing;
        }

        return html`<omega-progress card></omega-progress>`;
    }
}
